import React from 'react'
import { StyleSheet } from 'react-native'

import { B5, Stack } from '@zet/design-system'
import { i18n } from '@zet/localization'

import TierTag from '../../assets/svg/tierTag.svg'

const CardTag = () => {
  return (
    <Stack className="absolute -top-1 w-full items-center" style={styles.tag}>
      <TierTag />
      <B5
        className={`text-neutral-white100 absolute ${
          i18n.locale === 'hi' ? 'mt-0.5' : ''
        }`}
      >
        {i18n.t('brandDetails.youAreHere')}
      </B5>
    </Stack>
  )
}

export default CardTag
const styles = StyleSheet.create({
  tag: { zIndex: 10 },
})
